var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"numberedMode"}},[_c('div',{staticClass:"tip_box"},[_c('span',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.title)}}),_c('span',{staticClass:"tip",domProps:{"textContent":_vm._s(_vm.tip)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }